<div class="eff-select-wrapper" [ngClass]="{ 'is-disabled': formController.disabled }">
    <mat-form-field>
        @if (label) {
            <mat-label>{{ label }}</mat-label>
        }
        <mat-select
            #selector
            [formControl]="formController"
            hideSingleSelectionIndicator
            [panelClass]="panelClass"
        >
            @if (isTemplate) {
                <mat-select-trigger>
                    <ng-container
                        *ngTemplateOutlet="
                            selectedOptionTemplate;
                            context: { selectedOption: selectedOption }
                        "
                    >
                    </ng-container>
                </mat-select-trigger>
            }
            @for (option of options; track option) {
                <mat-option [value]="option.Id" [ngClass]="{ hide: option.Hide }">
                    @if (!isTemplate) {
                        <div [attr.data-uiid]="'new-eff-eff-select-option-' + option.Label">
                            {{ option.Label }}
                        </div>
                    }
                    @if (isTemplate) {
                        <ng-container>
                            <ng-container
                                *ngTemplateOutlet="optionTemplate; context: { option: option }"
                            >
                            </ng-container>
                        </ng-container>
                    }
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>
